import SectionSlider1 from "../../sections/home/index/section-slider1";
import SectionServices1 from "../../sections/home/index/section-services1";
import SectionAboutCompany1 from "../../sections/home/index/section-about-company1";
import SectionPricing1 from "../../sections/home/index/section-pricing1";
import { useEffect } from "react";
import { loadScript } from "../../../globals/constants";
import Seo from "../common/Seo";

function Home1Page() {
  useEffect(() => {
    loadScript("js/custom.js");
  });

  return (
    <>
      <Seo
        title="Website & App Development Company In Pune | Digital Marketing"
        description="DArchTech is a digital solutions company offering website, mobile app, and digital marketing services to grow your business online."
      />
      <SectionSlider1 />
      <SectionServices1 />
      <SectionAboutCompany1 />
      <SectionPricing1 />
      {/* <SectionWhyChooseUs1 /> */}
      {/* <SectionVideo1 /> */}
      {/* <SectionClients1 /> */}
      {/* <SectionCaseStudy1 /> */}
      {/* <SectionBlogs1 /> */}
    </>
  );
}

export default Home1Page;
